import { EntityList } from '@avangard/utils/entity';

import { SoaDocumentEntity } from './soa-document.entity';

import type { Entity } from './soa-document.entity';

class SoaDocumentEntityList extends EntityList<SoaDocumentEntity> {
    constructor(items: Entity[] | null, count?: number | null) {
        super(SoaDocumentEntity, items, count);
    }
}

export { SoaDocumentEntityList };
